import axios from 'axios'

axios.defaults.withCredentials = true

export default {
    state : { 
        baseUrl:process.env.API_URL,
        contact:{},
        user:{},
        users:[],
        customFields:[]
    },
    getters : {
        contact:(state)=>{
            return state.contact
        },
    },
    mutations : { 
    },
    actions : { 
        getContact({state,commit},form){

            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/getContact`,form)
                .then(response => {
                    console.log("getContact action response")
                    console.log(response)
                    if(response.data.status.code==0){
                        commit('contact',response.data.content.contact)
                        commit('user',response.data.user)
                        commit('users',response.data.users)
                        commit('customFields',response.data.content.customFields)
                        resolve(response.data)
                    }else{
                        resolve(false)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
            
        },
        updateContacts({state,commit},form){

            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/updateContacts`,form)
                .then(response => {
                    console.log("updateContacts action response")
                    console.log(response)
                    if(response.data.status.code==0){
                        // commit('contact',response.data.content.contact)
                        // commit('user',response.data.user)
                        // commit('users',response.data.users)
                        // commit('customFields',response.data.content.customFields)
                        resolve(response.data)
                    }else{
                        resolve(false)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
            
        },
        deleteContacts({state,commit},form){

            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/deleteContacts`,form)
                .then(response => {
                    console.log("deleteContacts action response")
                    console.log(response)
                    if(response.data.status.code==0){
                        /*
                        commit('organization',response.data.content.organization)
                        commit('user',response.data.user)
                        commit('users',response.data.users)
                        commit('organizationCustomFields',response.data.content.customFields)
                        resolve(response.data)
                        */
                       resolve(response.data)
                    }else{
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
            
        }
    }
}